import React from "react";
import { wsAxiosGet } from "src/helpers/wsAxios";

import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { showToast } from "src/app/methods/showToast";
import { RootState } from "src/redux/reducers";
import {
  openReportGenerator,
  ReportGeneratorContext,
} from "src/app/ReportGenerator/utils/reportFunctions";

import { ReactComponent as LightningIcon } from "src/images/lightning.svg";
import {
  Dropdown,
  DropdownMenu,
  DropdownMenuItem,
} from "../../../components/Dropdown/Dropdown";

import { Button } from "../../../components/Button/Button";
import { AppConfig } from "../../../../config/AppConfig";

import { ReactComponent as DownloadIcon } from "../../../../images/download.svg";
import { ReactComponent as ReportIcon } from "../../../../images/report.svg";

export function ProjectReportDropdown() {
  const history = useHistory();
  const {
    mainReducer: { activeWorkspaceUuid },
    projectReducer: { projectBasicData },
  } = useSelector((state: RootState) => state);

  const openReportGeneratorFunction = () => {
    if (!projectBasicData?.projectId) return;

    openReportGenerator({
      history,
      context: ReportGeneratorContext.Campaign,
      workspaceId: activeWorkspaceUuid,
      ids: [projectBasicData.projectId],
    });
  };

  if (!projectBasicData?.permissions?.project.includes("download_report")) {
    return null;
  }

  return (
    <Dropdown className="project-report-dropdown" toRight>
      {(isOpen, setIsOpen: React.Dispatch<React.SetStateAction<boolean>>) => (
        <>
          <Button
            variant="white"
            size="thin"
            onClick={() => setIsOpen((v) => !v)}
            dataQa="dropdown-report-button"
          >
            <ReportIcon />
            <IDHFormattedMessage id="ws_report" defaultMessage="Report" />
          </Button>

          <DropdownMenu isOpen={isOpen}>
            <DropdownMenuItem
              onClick={async () => {
                await wsAxiosGet({
                  url: `${AppConfig.getApiRoute()}/project/xlsx-report-file/${projectBasicData?.projectId}`,
                });
                showToast(
                  "success",
                  <IDHFormattedMessage id="ws_success" defaultMessage="Success" />,
                  <IDHFormattedMessage
                    id="ws_report_has_been_queued_sent_email"
                    defaultMessage="The report has been queued for sending via email"
                  />,
                );
              }}
              data-qa="download-xlsx-button"
            >
              <DownloadIcon />
              <IDHFormattedMessage
                id="ws_download_xlsx"
                defaultMessage="Download XLSX"
              />
            </DropdownMenuItem>

            <DropdownMenuItem
              onClick={openReportGeneratorFunction}
              data-qa="generate-report-button"
            >
              <LightningIcon />
              <IDHFormattedMessage
                id="ws_generate_report"
                defaultMessage="Generate report"
              />
            </DropdownMenuItem>
          </DropdownMenu>
        </>
      )}
    </Dropdown>
  );
}
